import { IBaseAction } from '../../constants';

export interface ReEstablishRequestState {
    data: {
        rpl: any;
        id: string;
    };
    error?: any
}

export interface ReEstablishRequestInitialState {
    rpl: any;
    id: string;
}

export const REESTABLISH_REQUEST = 'REESTABLISH_REQUEST';
export const REESTABLISH_REQUEST_SUCCESS = 'REESTABLISH_REQUEST_SUCCESS';
export const REESTABLISH_REQUEST_CLEAR = 'REESTABLISH_REQUEST_CLEAR';
export const REESTABLISH_REQUEST_FAILURE = 'REESTABLISH_REQUEST_FAILURE';
interface ReEstablishRequestAction extends IBaseAction {
    type: typeof REESTABLISH_REQUEST | typeof REESTABLISH_REQUEST_SUCCESS | typeof REESTABLISH_REQUEST_CLEAR | typeof REESTABLISH_REQUEST_FAILURE;
    payload: {
        data: ReEstablishRequestInitialState;
        error?: any;
    };
}

export const REESTABLISH_FLIGHTS_REQUEST = 'REESTABLISH_FLIGHTS_REQUEST';
export const REESTABLISH_FLIGHTS_REQUEST_SUCCESS = 'REESTABLISH_FLIGHTS_REQUEST_SUCCESS';
export const REESTABLISH_FLIGHTS_REQUEST_FAILURE = 'REESTABLISH_FLIGHTS_REQUEST_FAILURE';
export const REESTABLISH_FLIGHTS_REQUEST_CLEAR = 'REESTABLISH_FLIGHTS_REQUEST_CLEAR';
export interface ReestablishFlightSRequestAction extends IBaseAction {
    type:
    | typeof REESTABLISH_FLIGHTS_REQUEST
    | typeof REESTABLISH_FLIGHTS_REQUEST_SUCCESS
    | typeof REESTABLISH_FLIGHTS_REQUEST_FAILURE
    | typeof REESTABLISH_FLIGHTS_REQUEST_CLEAR;
    payload?: {
        data: any;
    };
}

export const REESTABLISH_FLIGHTS_AFTER_REJECTION = 'REESTABLISH_FLIGHTS_AFTER_REJECTION';
export const REESTABLISH_FLIGHTS_AFTER_REJECTION_SUCCESS = 'REESTABLISH_FLIGHTS_AFTER_REJECTION_SUCCESS';
export const REESTABLISH_FLIGHTS_AFTER_REJECTION_FAILURE = 'REESTABLISH_FLIGHTS_AFTER_REJECTION_FAILURE';
export const REESTABLISH_FLIGHTS_AFTER_REJECTION_CLEAR = 'REESTABLISH_FLIGHTS_AFTER_REJECTION_CLEAR';
export interface ReestablishFlightsAfterRejectionRequestAction extends IBaseAction {
    type:
    | typeof REESTABLISH_FLIGHTS_AFTER_REJECTION
    | typeof REESTABLISH_FLIGHTS_AFTER_REJECTION_SUCCESS
    | typeof REESTABLISH_FLIGHTS_AFTER_REJECTION_FAILURE
    | typeof REESTABLISH_FLIGHTS_AFTER_REJECTION_CLEAR;
    payload?: {
        data: any;
    };
}

export type FlightRequestActionTypes = ReEstablishRequestAction | ReestablishFlightSRequestAction | ReestablishFlightsAfterRejectionRequestAction;